import { render, staticRenderFns } from "./LogUrination.vue?vue&type=template&id=64b98e25&scoped=true&"
import script from "./LogUrination.vue?vue&type=script&lang=js&"
export * from "./LogUrination.vue?vue&type=script&lang=js&"
import style0 from "./LogUrination.vue?vue&type=style&index=0&id=64b98e25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b98e25",
  null
  
)

export default component.exports